module.exports = "dist/23203ae30462e0561b91645fe441afcd.svg";